<template>
    <div style="box-sizing: border-box;padding: 20px 0;">
        <div class="bk flx alc jsb">
            <div class="flx alc cursor" style="height: 100%;" @click="bobk">
                <i class="el-icon-arrow-left" style="margin-right: 8px;"></i> 返回
            </div>
            <div class="search flx alc jsb">
                <div class="inp">
                    <input type="text" v-model="keyword" placeholder="请输入搜索关键词" />
                </div>
                <div class="searchBtn cursor" @click="searchs">
                    搜索
                </div>
            </div>
            <div class="flx alc">
                <el-button @click="dialogVisible = true,type=0" type="primary">新增渠道</el-button>
                <el-button @click="jp" type="primary">下载全部二维码</el-button>
            </div>

        </div>
        <div class="fs">
            <el-table ref="multipleTable" :data="array" tooltip-effect="dark" style="width: 100%"
                @selection-change="handleSelectionChange">
                <!--       <el-table-column type="selection" width="55">
                </el-table-column> -->
                <el-table-column prop="name" label="渠道名称" width="200">
                </el-table-column>
                <el-table-column prop="pc_link" label="渠道链接" width="220">

                </el-table-column>
                <el-table-column label="渠道二维码" width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <img style="height: 50px;height: 50px;" :src="$img(scope.row.xcx_qrcode)" alt="" />
                    </template>
                </el-table-column>
                <el-table-column prop="view_num" label="浏览量" width="120" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="enroll_num" label="报名量" width="120" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="income_num" label="总收入(元)" width="120" show-overflow-tooltip>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="340">
                    <template slot-scope="scope">
                        <el-button @click="copy(scope.row)" type="text" size="small">复制链接</el-button>
                        <el-button @click="downloadqrcode(scope.row)" type="text" size="small">下载小程序码</el-button>
                        <el-button @click="downdetail(scope.row)" type="text" size="small">明细</el-button>
                        <el-button @click="delThis(scope.row)" type="text" size="small">删除渠道</el-button>
                        <el-button @click="editThis(scope.row)" type="text" size="small">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>


            <div style="padding: 20px 0;">
                <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
                    :total="totals">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="新增渠道" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <!-- 多行文本框 -->
            <el-input v-model="textareaVal" type="text" placeholder="请输入渠道名称" maxlength="15"></el-input>

            <!-- 底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false,textareaVal = ''">取消</el-button>
                <el-button type="primary" @click="submit">确定提交</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import {
        getChannelList,
        addChannel,
        delChannel
    } from "@/api/index.js"
    export default {
        data() {
            return {
                totals: 0,
                id: "",
                page: 1,
                size: 20,
                array: [],
                dialogVisible: false,
                textareaVal: "",
                keyword: '',
                channel_id:"",
                type:0
            }
        },
        created() {
            this.id = this.$route.query.id
            this.getList()
            this.$nextTick(() => {
                window.scrollTo(0, 0)
            })
        },
        methods: {
            downdetail(e){
                let that = this 
                window.open(that.$baseUrl + '/api/Index/activity_channel_download_excel?source=channel&channel_id=' + e.id)
            },
            searchs() {
                let that = this
                let data = {}
                that.page = 1
                data.size = that.size
                data.page = that.page
                data.keywords = that.keyword
                data.activity_id = that.id
                getChannelList(data).then((res) => {
                    if (res.code == 1) {
                        that.array = res.data.data
                        that.totals = res.data.total
                    }
                })
            },
            downloadqrcode(e){
                window.open(this.$imageUrl+e.xcx_qrcode)
            },
            editThis(e){
                let that = this
                 this.dialogVisible = true
                 this.channel_id = e.id
                 this.textareaVal = e.name
                 this.type = 1
            },
            async copy(e) {
                try {
                    await navigator.clipboard.writeText(e.pc_link)
                    this.$message.success('复制成功')
                } catch (e) {
                    alert('复制失败')
                }
            },
            jp() {
                let that = this
                window.open(that.$baseUrl + '/api/Index/activity_channel_download_qrcode?activity_id=' + that.id)
            },
            delThis(e) {
                console.log(e)
                let that = this
                let data = {}
                data.id = e.id
                that.$confirm('确定要删除该渠道吗?', ' ', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delChannel(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            submit() {
                let that = this
                let data = {}
                data.activity_id = that.id
                data.name = that.textareaVal
                if(that.type == 1){
                    data.id = that.channel_id
                }
                addChannel(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.dialogVisible = false
                        that.textareaVal = ''
                        that.$message.success(res.msg)
                        that.getList()
                    }
                })

            },
            // 关闭弹窗回调
            handleClose() {
                this.dialogVisible = false
                this.textareaVal = '' // 关闭清空内容
            },
            getList() {
                let that = this
                let data = {}
                data.page = that.page
                data.size = that.size
                data.activity_id = that.id
                getChannelList(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.array = res.data.data
                        that.totals = res.data.total
                    }
                })
            },
            handleCurrentChange(e) {
                console.log(e)
            },
            addChannel() {

            },
            bobk() {
                this.$router.go(-1)
            },
            handleClick(e) {
                console.log(this.activeName)
                this.page = 1
                this.getList()
            },
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                console.log(val)
                this.multipleSelection = val;
            }
        }
    }
</script>

<style scoped>
    .channels {}

    .fs {
        width: 1460px;
        background-color: #fff;
        margin: 0 auto;
    }

    .bk {
        width: 1460px;
        height: 68px;
        background: #FFFFFF;
        box-sizing: border-box;
        padding: 0 30px;
        margin: 0 auto 20px;
        font-size: 14px;
        color: #000000;
    }
</style>